export class ClickEventHandler {
  constructor() {
    this.regexSelf = /((click)(#[\da-fA-F]{6})?(#bg\{(.*?)\})?)/g;
    this.regexAll =
      /((click)(#[\da-fA-F]{6})?(#bg\{(.*?)\})?)?(,(show_)?(ssm\w+)(#[\da-fA-F]{6})?(#bg\{(.*?)\})?)/g;
  }
  async handleClick(ev) {
    let target = ev.target;
    await this.handleClickId(target);
    await this.handleClickRegex(target);
  }
  async handleClickId(target) {
    if (/click_(\d+)/gi.test(target.outerHTML)) {
      let id = /click_(\d+)/gi.exec(target.outerHTML)[1];
      for (const pageItem of this.pageList) {
        if (parseInt(id) === parseInt(pageItem.pageId)) {
          await this.initTemplateData(pageItem);
          break;
        }
      }
    }
  }

  parseExecResult(result) {
    const execArr = this.regexAll.exec(result);
    return {
      event: execArr ? execArr[2] : null,
      color: execArr && execArr[3] ? execArr[3].toLowerCase() : null,
      background: execArr ? execArr[5] : null,
      show: execArr ? execArr[7] : null,
      className: execArr ? execArr[8] : null,
      classColor: execArr && execArr[9] ? execArr[9].toLowerCase() : null,
      classBackground: execArr ? execArr[11] : null,
    };
  }

  async handleClickRegex(target) {
    if (this.regexAll.test(target.outerHTML)) {
      target.outerHTML.match(this.regexAll).forEach((result) => {
        this.regexAll.lastIndex = 0;
        const { event, color, background, show, className, classColor, classBackground } =
          this.parseExecResult(result);
        let oldFontColor = target.style.color ? this.rgbToHex(target.style.color) : "";
        //根据是否含有子元素来判断是否是按钮变色事件，如果是则将子元素的color赋值给oldFontColor
        if (target.children.length > 0) {
          oldFontColor = this.rgbToHex(target.children[0].style.color);
        }
        if (event === "click" && color) {
          this.changeColor(target, oldFontColor, color);
        }
        if (event === "click" && background) {
          this.changeBackgroundColor(target, background);
        }

        //查询相匹配的class其他元素,变色/显隐
        const elementsWithClass = Array.from(document.getElementsByClassName(className));
        elementsWithClass.forEach(($el) => {
          this.regexAll.lastIndex = 0;
          //文字变色
          if (className && !classColor && color) {
            $el.style.color = oldFontColor === color ? "initial" : color;
          } else if (className && classColor) {
            const oldColor = this.rgbToHex($el.style.color);
            this.changeColor($el, oldColor, classColor);
          }
          //显示、隐藏
          if (show) {
            $el.style.visibility = $el.style.visibility === "hidden" ? "visible" : "hidden";
          }
          //背景色
          if (classBackground) {
            this.changeBackgroundColor($el, classBackground);
          }
        });
      });
    } else if (!this.regexAll.test(target.outerHTML) && this.regexSelf.test(target.outerHTML)) {
      target.outerHTML.match(this.regexSelf).forEach((result) => {
        this.regexAll.lastIndex = 0;
        this.regexSelf.lastIndex = 0;
        const execArr = this.regexSelf.exec(result);
        const fontColor = execArr[3] ? execArr[3].toLowerCase() : null;
        const background = execArr[5];
        let oldFontColor = target.style.color ? this.rgbToHex(target.style.color) : "";
        //根据是否含有子元素来判断是否是按钮变色事件，如果是则将子元素的color赋值给oldFontColor
        if (target.children.length > 0) {
          oldFontColor = this.rgbToHex(target.children[0].style.color);
        }
        if (fontColor) {
          this.changeColor(target, oldFontColor, fontColor);
        }
        if (background) {
          this.changeBackgroundColor(target, background);
        }
      });
    }
  }

  changeBackgroundColor($el, newBg) {
    let oldBg = this.rgbToHex($el.style.background).toLowerCase();
    if (!$el.getAttribute("bg")) {
      $el.setAttribute("bg", oldBg);
      $el.style.background = newBg;
    } else {
      $el.style.background = $el.getAttribute("bg");
      $el.removeAttribute("bg");
    }
    Array.from($el.children).map((childEl) => {
      childEl.style.color = $el.style.color;
    });
    this.regexAll.lastIndex = 0;
    this.regexSelf.lastIndex = 0;
  }

  changeColor($el, oldColor, newColor) {
    if (oldColor !== newColor || !$el.getAttribute("color")) {
      $el.setAttribute("color", oldColor);
      $el.style.color = newColor;
    } else {
      $el.style.color = $el.getAttribute("color");
    }
    this.regexAll.lastIndex = 0;
    this.regexSelf.lastIndex = 0;
  }

  /**
   * rgb转hex
   * @returns 最终rgb转hex的值，如：64,158,255 -> #409EFF
   */
  rgbToHex(val) {
    //十六进制颜色值的正则表达式
    const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    // 如果是rgb颜色表示
    if (/^(rgb|RGB)/.test(val)) {
      let aColor = val.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
      let strHex = "#";
      for (let i = 0; i < aColor.length; i++) {
        let hex = Number(aColor[i]).toString(16);
        if (hex.length < 2) {
          hex = "0" + hex;
        }
        strHex += hex;
      }
      if (strHex.length !== 7) {
        strHex = val;
      }
      return strHex;
    } else if (reg.test(val)) {
      let aNum = val.replace(/#/, "").split("");
      if (aNum.length === 6) {
        return val;
      } else if (aNum.length === 3) {
        let numHex = "#";
        for (let i = 0; i < aNum.length; i += 1) {
          numHex += aNum[i] + aNum[i];
        }
        return numHex;
      }
    }
    return val;
  }
}
